// export const API_URL = 'https://api.mirror.edunixsystem.com/'
export const API_URL = 'https://api.motherland.edunixsystem.com/'
// export const API_URL = 'https://api.albayan-schools.com/'
// export const API_URL = 'https://api.rowadalmustakbal.edunixsystem.com/'
// export const API_URL = 'https://api.shamsalassil.edunixsystem.com/'
// export const API_URL = 'https://api.almarah-school.edunixsystem.com/'
// export const API_URL = 'https://api.sawa.edunixsystem.com/'
// export const API_URL = 'https://al-awdah.beetronix.com/'
// export const API_URL = 'https://api.aljenan.edunixsystem.com/'
// export const API_URL = 'https://api.gelalshahbaa.edunixsystem.com/'
// export const API_URL = 'https://api.alrowad-school.edunixsystem.com/'
// export const API_URL = 'https://api.alawal.edunixsystem.com/'
// export const API_URL = 'https://api.alawalschool.edunixsystem.com/'
// export const API_URL = 'https://api.al-qalaji.edunixsystem.com/'
